// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"87efbf34","202":"87efbf34","262":"f00c488b","282":"87efbf34","461":"2a811ee7","551":"1973d63b","630":"87efbf34","740":"a49c6251"}[chunkId] + ".chunk.css";
};